import { defineMessages } from 'react-intl'

const scope = 'app.containers.FatcaTablePage'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'FATCA',
  },
  count: {
    id: `${scope}.count`,
    defaultMessage: 'Entities | Displaying {displayed} of {total}',
  },
  filters: {
    id: `${scope}.filters`,
    defaultMessage: 'Filters',
  },
})
